import { z } from "zod";
import { MIMETypeSchema } from "./IMIMEType";

export const documentSchema = z.object({
    id: z.number(),
    file_name: z.string(),
    data: z.string().optional(),
    MIMEtype: MIMETypeSchema,
});

export type IDocument = z.infer<typeof documentSchema>;
